/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
import React from 'react';
import isCrawlers from 'common/utils/isCrawlers';
import MotorcycleRentalView from 'views/motorcycle_rental/MotorcycleRental';
import { geoPageSlugTypes, placeSlugTypes } from 'views/motorcycle_rental/utils/constants';
import handleGeoSSR from 'views/motorcycle_rental/utils/handleGeoSSR';
import getLocalizedUrl from 'utils/getLocalizedUrl';
import { Router, i18n } from 'config/i18n';
import { handleDetectSlugsSSR } from 'utils/handleDetectSlugsSSR';
import serverLogger from 'utils/serverLogger';
import Error from 'components/shared/Error';

const Geo = (props) => {
  const {
    serverData, slugSSR, ssrRender, hreflangData, errorStatusCode,
  } = props;
  if (errorStatusCode) {
    return <Error statusCode={errorStatusCode || 500} />;
  }
  return (
    <>
      <MotorcycleRentalView
        serverData={serverData}
        slugData={slugSSR}
        ssrRender={ssrRender}
        hreflangData={hreflangData}
      />
    </>
  );
};

Geo.getInitialProps = async (ctx) => {
  serverLogger.debug('---[Trace] Inside Geo getInitialProps');

  const { req, res, query } = ctx;
  const locale = req ? req.locale : 'en';
  const ssrRender = req ? isCrawlers(req.headers['user-agent']) : false;

  const { slug_1, slug_2, slug_3 } = query;
  const slugsArr = [slug_1, slug_2, slug_3].filter((item) => !!item);

  const detectSlugBody = {
    slugs: slugsArr.map((slugItem) => ({
      slug: slugItem,
      expected_types: [...geoPageSlugTypes],
    })),
  };
  const {
    renderErrorPage,
    newPath,
    slugSSR = {},
  } = await handleDetectSlugsSSR(ctx, detectSlugBody, locale);

  if (renderErrorPage) {
    if (typeof window === 'undefined') {
      res.statusCode = 503;
      return { namespacesRequired: [] };
    }
    return {
      errorStatusCode: 404,
    };
  }

  if (newPath) {
    if (typeof window === 'undefined') {
      res.writeHead(301, { Location: newPath });
      res.end();
      return {};
    }

    Router.push(newPath);
  }
  const { slugs } = slugSSR;
  if (slugs.length === 1 && placeSlugTypes.includes(slugs[0].slug_type)) {
    const rental = req ? req.t('routes:motorcycle-rental') : i18n.t('routes:motorcycle-rental');
    const destUrl = getLocalizedUrl(`/${encodeURIComponent(rental)}/${encodeURIComponent(slugs[0].slug)}`, locale);

    if (typeof window === 'undefined') {
      res.writeHead(301, { Location: destUrl });
      res.end();
      return {};
    }
    Router.push(destUrl);
  }

  let pageRes = {};
  if (ssrRender && ctx.pathname != '/_error') {
    pageRes = await handleGeoSSR(ctx, slugSSR);
    if (pageRes.redirect) {
      return pageRes;
    }
  }

  return {
    namespacesRequired: [
      'fe_es_geo_widget',
      'fe_es_geo_page',
      'fe_bike_card',
      'fe_geo_filters',
      'pagination',
      'fe_es_common_main_widget',
      'routes',
    ],
    ...pageRes,
    ssrRender,
    slugSSR,
    suppressSpinner: true,
  };
};

export default Geo;
